/**
 * WARNING: The use of `require` and `module.exports` is because this package has to remain
 * in CommonJS format. Do not change ANY files here to ES6 standards or it will break usages.
 */

"use strict";

const { isNullOrEmpty, getProp } = require("./objects");
const { isString } = require("./strings");
const { fromJsonString } = require("./json");
const { getFullUrl, getUrlWithExtention } = require("./urls");
const { arrayDifference } = require("./arrays");
const { getLocaleInfo } = require("./locale");

module.exports = {
  isNullOrEmpty,
  getProp,
  isString,
  fromJsonString,
  getFullUrl,
  getUrlWithExtention,
  arrayDifference,
  getLocaleInfo
};
